enum StoreActions {
  HIDE_MODAL = 'MODALS/HIDE_MODAL',
  SHOW_MODAL = 'MODALS/SHOW_MODAL',
}

export const ActionTypes_Modals = {
  StoreActions,
}
